<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options">
      <div v-if="props.row.statut" slot="statut" slot-scope="props" class="slot-center">
        <span class="badge badge-success p-1"><i class="fa fa-check"></i></span>
      </div>
      <div v-else class="slot-center">
        <span class="badge badge-danger p-1"><i class="fa fa-close"></i></span>
      </div>
      
      <div slot="actif" slot-scope="props" class="slot-center">
        <span class="badge badge-success p-1" v-if="props.row.is_active"><i class="fa fa-check"></i></span>
        <span class="badge badge-danger p-1" v-else><i class="fa fa-close"></i></span>
      </div>

      <div v-if="props.row.date_creation" slot="date_creation" slot-scope="props" class="slot-date">
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_creation) }}</span>
      </div>

      <div v-if="props.row.nsi" slot="nsi" slot-scope="props" class="slot-number slot-idpp">
        <span  v-if="canAccess(rules.ACCESS_BENEFICIAIRES)">
          <a class="fiche-beneficiaire slot-number" href="#" @click.prevent="fiche(props.row.id)">{{ props.row.nsi }}</a></span>
        <span v-else>
          {{ props.row.nsi }}
        </span>
      </div>

      <div v-if="props.row.nir" slot="nir" slot-scope="props" class="slot-number">
          <span>{{ formatNir(props.row.nir) }}</span>
      </div>
      <div v-if="props.row.nom" slot="prenom" slot-scope="props">
          <span>{{ props.row.nom.toUpperCase() }}</span>
      </div>
      <div v-if="props.row.prenom" slot="prenom" slot-scope="props">
          <span>{{ props.row.prenom[0].toUpperCase() + props.row.prenom.slice(1).toLowerCase() }}</span>
      </div>

      <div v-if="props.row.telephone" slot="telephone" slot-scope="props" class="slot-number">
        <span>{{ props.row.telephone }}</span>
      </div>
      <div v-if="props.row.siret" slot="siret" slot-scope="props" class="slot-number">
        <span>{{ props.row.siret }}</span><br>
        <span>{{ getLibProduit(props.row) }}</span>
      </div>
    </v-server-table>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "../utils/auth";
import {espaceBeneficiaireRules, hasRule} from '../utils/rulesHelper'

export default {
  name: "InscriptionTable",
  props: ["tableEntry"],
  data() {
    let self = this;
    return {
      rules: espaceBeneficiaireRules,
      url: '',
      columns: [
        "date_creation",
        "nsi",
        "nir",
        "nom",
        "prenom",
        "email",
        "telephone",
        "siret",
        "type_rente",
        "statut",
        "actif"
      ],
      items: [],
      options: {
        headings: {
          nsi: "N° Ident. NSI",
          nir : "N° Sécu. Soc.",
          nom: "Nom",
          prenom: "Prénom",
          email: "Email",
          telephone: "Téléphone",
          siret: "Siret\nProduit",
          date_creation: "Date de création",
          type_rente: "Type de rente",
          statut: "Compte Activé",
          actif: "Bénéf. Actif"
        },
        columnsClasses: {
          telephone: "action-md"
        },
        sortable: ["nsi", "nom"],
        filterable: false,
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: "N°Identifiant NSI, Email"
        },
        requestFunction: function (data) {
            self.url = '/espaceBeneficiaire/inscriptions/recherche'
            data["num_nsi"] = self.tableEntry.num_nsi;
            data["nir"] = self.tableEntry.nir;
            data["num_dossier"] = self.tableEntry.num_dossier;
            data["nom"] = self.tableEntry.nom;
            data["prenom"] = self.tableEntry.prenom;
            data["email"] = self.tableEntry.email;
            data["is_active"] = self.tableEntry.is_active;
            data["is_mailable"] = self.tableEntry.is_mailable;
            data["is_register"] = self.tableEntry.is_register;

            self.$store.commit("IS_LOADING", true);

            return axios.get(self.url, {
                params: data
            })
            // .then((response) => {
            //   console.log(response)
            // })
            .catch(function (e) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 5000
              });
            }.bind(this));
        }
      }
    };
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    onLoaded(){
      this.$store.commit("IS_LOADING", false);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    },
    formatNir(textNir) {
      if(textNir !== null  && textNir !== ''){

        let nirs = textNir.split(',');
        let displayNir = '';

        nirs.forEach(function (element){
          if(element.length > 13){
            if(displayNir === ''){
              displayNir = element.substring(0,13);
            }else{
              displayNir = displayNir + '\n' + element.substring(0,13);
            }
          }
        });
        return displayNir;
      }else{
        return textNir;
      }
    },
    fiche(id) {
      this.$router.push({ path: '/espace-beneficiaire/beneficiaires/fiche/' + id })
    },
    getLibProduit(row) {
      let libelleProduit = '';
      if (row.produit_dc) {
        libelleProduit = libelleProduit + ' ' + row.produit_dc;
      }
      if (row.produit_inval) {
        libelleProduit = libelleProduit + ' ' + row.produit_inval;
      }

      return libelleProduit.trim();
    },
  }
};
</script>

<style scoped>
.VueTables__search-field input {
  width: 240px !important; 
}
</style>